export class User {
  id?: number;
  username?: string;
  email?: string;
  imageUrl?: string;
  accessToken?: string;
  firstName?: string;
  lastName?: string;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

  // Session Management Methods (equivalent to SessionManager)
  saveAccessToken(token: string): void {
    this.accessToken = token;
  }

  getAccessToken(): string | undefined {
    return this.accessToken;
  }

  saveUserData(id: number, username: string, email: string, imageUrl?: string): void {
    this.id = id;
    this.username = username;
    this.email = email;
    this.imageUrl = imageUrl;
  }

  getUserId(): number | undefined {
    return this.id;
  }

  getUsername(): string | undefined {
    return this.username;
  }

  getEmail(): string | undefined {
    return this.email;
  }

  getImageUrl(): string | undefined {
    return this.imageUrl;
  }

  clearSession(): void {
    this.id = undefined;
    this.username = undefined;
    this.email = undefined;
    this.imageUrl = undefined;
    this.accessToken = undefined;
  }
}